import { useCreateKontoausgleichSchema } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/components/useCreateKontoausgleichSchema';
import { useCreateKontoausgleich } from '@/domain/mitarbeiter/features/feiertagskonto/hooks';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import z from 'zod';
import { useAppForm } from '@/components/form';
import {
  KontoausgleicheArt,
  mappedGqlArtToDomainArt,
} from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import dayjs from 'dayjs';

export function useCreateKontoausgleichForm(mitarbeiterId: string) {
  const [createKontoausgleich] = useCreateKontoausgleich();
  const schema = useCreateKontoausgleichSchema();
  const { t } = useTranslation();
  const form = useAppForm({
    defaultValues: {
      art: KontoausgleicheArt.FEIERTAGSAUSZAHLUNG,
      bemerkung: '',
      datum: dayjs().toISOString(),
      tage: '1',
    } satisfies z.infer<typeof schema> as z.infer<typeof schema>,
    validators: {
      onBlur: schema,
    },
    onSubmit: async ({ value }) => {
      const tage = Number(value.tage.replace(',', '.'));
      const input = {
        mitarbeiterId,
        art: mappedGqlArtToDomainArt(value.art),
        bemerkung: value.bemerkung,
        datum: value.datum,
        tage: tage,
      };

      createKontoausgleich({
        input: { ...input },
      })
        .then(() =>
          toast({
            variant: 'success',
            title: t(
              'domain.mitarbeiter.feiertagskonto.kontoausgleich.form.toast',
            ),
          }),
        )
        .catch(() => {
          toast({
            variant: 'destructive',
            title: t(
              'domain.mitarbeiter.feiertagskonto.kontoausgleich.form.toastFail',
            ),
          });
        });
    },
  });

  return { form };
}
